import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from './authReducer';
import snackBarReducer from "./snackBarReducer";
import userReducer from './userReducer';
import artworkReducer from "./artworkReducer";
import aiReducer from './aiReducer';
import { composeWithDevTools } from "redux-devtools-extension";

const rootReducer = combineReducers({
    authState: authReducer,
    snackBarState: snackBarReducer,
    userState: userReducer,
    artworkState: artworkReducer,
    aiState: aiReducer
})


export default configureStore({
    reducer: rootReducer
}, composeWithDevTools);